import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'
import { primary_color } from '../../../../Helper/uiHelper'

const TicketBookingId = ({ isEditMode, data, setUpdatedData }) => {
  const bookingId = data?.ticket?.booking_id
  const [value, setValue] = useState(bookingId || '')

  useEffect(() => {
    setValue(bookingId || '')
  }, [bookingId])

  if (!isEditMode) {
    return (
      <div
        className='subtitle1 text-muted cursor-pointer'
        onClick={() => {
          if (!bookingId) return
          const url = '/purchase-list?' + 'selected_ids=' + bookingId + '&search_field=booking_id'
          window.open(url, '_blank')
        }}
        style={{
          color: primary_color,
          textDecoration: bookingId ? 'underline' : undefined,
        }}>
        {bookingId || 'N/A'}
      </div>
    )
  }

  return (
    <AvForm>
      <AvField
        name='booking_id'
        value={value}
        className='subtitle1'
        placeholder='Booking ID (optional)'
        onChange={(e) => {
          const next = e.target.value
          setValue(next)
          setUpdatedData((prev) => ({
            ...prev,
            booking_id: next,
          }))
        }}
      />
    </AvForm>
  )
}

export default TicketBookingId
